import React from 'react';
export function AdditionalLinksSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-1486">
      <p className="text-gray-500 mb-6 italic border-b border-gray-100 pb-4" data-id="element-1487">
        Additional product information linked below
      </p>
      <div className="space-y-4" data-id="element-1488">
        <a href="/BodorLaserCutting.html" className="text-xl font-bold text-navy hover:text-orange transition-colors block" data-id="element-1489">
          Bodor High Power Fiber Laser Cutting Machines
        </a>
        <ul className="list-disc list-inside space-y-2 text-lg ml-4" data-id="element-1490">
          <li data-id="element-1491">
            <a href="/BodorLaserCutting.html#Bodor_high_power_laser_cutting_machines" className="text-orange hover:underline" data-id="element-1492">
              High Power
            </a>
          </li>
          <li data-id="element-1493">
            <a href="/BodorLaserCutting.html#high_precision_laser_cutting_machines" className="text-orange hover:underline" data-id="element-1494">
              High Precision
            </a>
          </li>
          <li data-id="element-1495">
            <a href="/BodorLaserCutting.html#Laser_Tube_Cutting_Machines" className="text-orange hover:underline" data-id="element-1496">
              Laser Tube Cutter
            </a>
          </li>
        </ul>
      </div>
    </div>;
}